import { observer } from "mobx-react-lite";
import useFitBounds from "../hooks/useFitBounds";
import { InitiatorType } from "../hooks/useFlyTo";
import Shape from "../interfaces/Shape";
import DetailsPanel, { IDetailsPanelProps } from "./DetailsPanel";

function DetailsPanelWithFitBounds({ shape, ...props }: IDetailsPanelWithFitBoundsProps) {
    useFitBounds(shape, InitiatorType.Details);

    return (
        <DetailsPanel {...props} />
    );
}

export default observer(DetailsPanelWithFitBounds);

export interface IDetailsPanelWithFitBoundsProps extends IDetailsPanelProps {
    shape: Shape;
}